export { hexAlpha } from './hexAlpha'
